import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule } from '@angular/forms';
import { ProjectsService } from '@cosmos/angular/api';
import { ErrorService } from '@cosmos/angular/utils';
import { Project } from '@cosmos/shared';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';

@Component({
    selector: 'cosmos-project-notifications-settings',
    imports: [TranslatePipe, ReactiveFormsModule,
        DividerModule, AutoCompleteModule, CheckboxModule, ButtonModule],
    templateUrl: 'project-notifications-settings.component.html'
})

export class ProjectNotificationsSettingsComponent implements OnInit {

    @Input()
    project: Project = null;

    @Output()
    updatedProject = new EventEmitter<Project>();

    notificationsConfig;

    constructor(
        private projectsService: ProjectsService,
        private formBuilder: FormBuilder,
        private errorService: ErrorService,
        public translateService: TranslateService,
    ) { }

    ngOnInit() { 
        this.notificationsConfig = this.formBuilder.group({
        emails: new FormControl(this.project.notificationsConfig?.emails),
        channels: this.formBuilder.group({
            app: this.project.notificationsConfig?.channels?.app, 
            email: this.project.notificationsConfig?.channels?.email
        })
    });
     }

    updateProject(updateObject) {
        const notificationsConfig = this.project.notificationsConfig;
        notificationsConfig.channels = updateObject.value.channels;
        notificationsConfig.emails = updateObject.value.emails;

        this.projectsService.update([this.project._id, {notificationsConfig: notificationsConfig}]).subscribe({
            next: (response) => this.updatedProject.emit(response.body),
            error: (e) => this.errorService.handleError(e)
        });
    }
}